import Views from '../../views/entry/athleteUser/AthleteUserViews';
import getInitialStateOmeRoute from './GetInitialStateOmeRoute';
import getInitialStateMeetRoute from './GetInitialStateMeetRoute';
import { rosterEntriesIsComplete } from './LeftNavValidation';

const getRosterEntries = (viewName, route, orgUnitAthleteEntryInfoStateObjData) => {
  const isCurrent = viewName === Views.OME_MEET_ROSTER_ENTRIES_DETAIL

  const arePrerequisitesDone = true;

  const isComplete = rosterEntriesIsComplete(orgUnitAthleteEntryInfoStateObjData) === true;

  const item = route === '' ? getInitialStateOmeRoute(Views.OME_MEET_ROSTER_ENTRIES_DETAIL) : getInitialStateMeetRoute(Views.OME_MEET_ROSTER_ENTRIES_DETAIL);

  return {
    ...item,
    isCurrent,
    isComplete,
    arePrerequisitesDone
  };
};

export default getRosterEntries;